<mat-table [dataSource]="items">
  <ng-container matColumnDef="searchparameter">
    <mat-header-cell *matHeaderCellDef> Search Parameter </mat-header-cell>
    <mat-cell *matCellDef="let item">
      {{ item?.searchParameter }}
      <sn-button
        type="button"
        matTooltip="Search"
        matTooltipPosition="after"
        (click)="whoosterSearch(item)"
      >
        <sn-icon fontIcon="fa-magnifying-glass" fontSet="fa-solid"></sn-icon> </sn-button
    ></mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row *matRowDef="let item; columns: columns"></mat-row>
</mat-table>
